import React from "react";
import { createPreferencesObject, IPreferenceFormComponent } from '../components/menu/preferences/PreferenceForm';
import DeletePreferences from "../components/menu/preferences/DeletePreferences";
import FormTitle from "../yoello-lib/modules/dynamicForms/FormComponents/FormTitle";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import { FieldFormExtender } from "../yoello-lib/modules/dynamicForms/FieldFormExtender";
import { PreferenceEntity } from "../components/menu/preferences/PreferenceEntity";

export const preferenceForm = (t: (key: string) => string, props: IPreferenceFormComponent, isEposNow: boolean, isNewItem: boolean): IDynamicFormRow[] => {
    let formRows: IDynamicFormRow[] = [
        {
            label: "",
            keyName: "details-subheading",
            Component: () => <FormTitle title={t("menu.subcategories.generalInfo")} />,
        },
        {
            label: "preferences.optionname", keyName: "name_public", Component: FormTextBox,
            registerOptions: { required: true, minLength: 3 }, gridColumnOptions: {
                formCol: 6
            }
        },
        {
            label: "preferences.internal", keyName: "name_internal",
            registerOptions: { required: true, minLength: 3 },
            Component: FormTextBox, gridColumnOptions: {
                formCol: 6
            }
        },
        {
            label: "preferences.items", Component: FieldFormExtender,
            keyName: "preferences", formProps:
            {
                Component: PreferenceEntity,
                createNewObjectFunction: createPreferencesObject,
                buttonLabel: 'preferences.button'
            },
            registerOptions: {
                required: true,
                shouldUnregister: true
                // validate: (options: any) => {
                //     // if (!options) return true;

                //     // for (const keys in options) {
                //     //     const prefName = options[keys].preference_name;
                //     //     if (!prefName || prefName.length === 0) {
                //     //         return t('menu.preferences.prefNameError')
                //     //     }
                //     // }
                //     // return true;
                // }
            }
        }
    ];

    if (!isNewItem && !isEposNow) {
        formRows = [...formRows, {
            label: "",
            keyName: "delete",
            Component: () => <DeletePreferences properties={props} />
        }]
    }

    return formRows
};